export interface LoadingDialogConfiguration {
    label: string;
    closeCallback?: () => void;
    value?: number | string;
}

export interface QrDialogConfiguration {
    /** special layout if "arDialog" */
    title: string;
    url: string;
    expiryDate?: Date;
    buttons?: Array<DialogSimpleButton>;
}

export interface ImpressDialogConfiguration extends QrDialogConfiguration {
    hideCheckbox?: boolean;
}

type InputDialogBaseButtonCallback =
    (() => void) |
    ((value?: string) => void) |
    ((value: string) => void);

interface InputDialogBaseButtonProps {
    orientation?: 'start' | 'end',
    label: string;
    key: string;
    checkInput?: boolean;
    preventCloseCall?: boolean;
    mainButton?: boolean;
    additionalProps?: unknown;
}

export interface DialogSimpleButton {
    label: string;
    callback: () => void;
}

export type InputDialogBaseDefaultButton = InputDialogBaseButtonProps & {
    type?: 'click';
    callback?: InputDialogBaseButtonCallback;
};

type InputDialogBaseLinkButton = InputDialogBaseButtonProps & {
    type: 'link';
    href: string;
    download?: string;
};

export type InputDialogBaseButton = InputDialogBaseDefaultButton | InputDialogBaseLinkButton;

export function isLinkButton(value: InputDialogBaseButton): value is InputDialogBaseLinkButton {
    return value.type === 'link';
}